"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class IAFormValidator {
    static mmInchLaengenValidator(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static fussbreite(options) {
        return IAFormValidator.mmInchLaengenValidator(options);
    }
    static abstand(options) {
        return IAFormValidator.mmInchLaengenValidator(options);
    }
}
exports.IAFormValidator = IAFormValidator;
//# sourceMappingURL=IAFormValidator.js.map